import { CSSProperties, useEffect } from "react";
import Header, { HEADER_ELEMENT_HEIGHT } from "elements/Header";
import Colors from "modules/Colors";
import { makeKey, styx } from "modules/Utils";
import useScreen from "Hooks/useScreen";
import AdCreatorPage from "components/AdCreatorPage";
import PageSymphony from "elements/PageSymphony";
import TrustedBy from "assets/images/trusted-by.svg";
import { pageView, track } from "analytics";

const HomePage = () => {
    const {
        cssCalc,
        mStyle
    } = useScreen();

    // Track homepage visit on mount
    useEffect(() => {
        pageView('ADBOX New Homepage', {
            version: 'v1',
            source: 'direct'
        });
        
        track('ADBOX New Homepage Visit', {
            version: 'v1',
            timestamp: new Date().toISOString()
        });
    }, []);

    // Carousel images data
    const carouselImages = [
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/6644e2406e5272cdf61b7dca_sza.webp', alt: 'SZA' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/6748060268e9755d6d710465_UNIVERSAL-Carousel-Imag.svg', alt: 'Universal Logo' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/66ba9834588ded2ffe1f546a_Summer.webp', alt: 'Summer Walker' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/681be1a62c2022ec9eb172b2_Podcasters-v2.svg', alt: 'Podcasters' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/66ba9822ca5d1abbb21defa6_Tinashe.webp', alt: 'Tinashe' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/681be1a649366f4c18e7f64a_Newsletters-v2.svg', alt: 'Newsletters' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/66ba984db17296cab91c1f24_Cash%20cobain.webp', alt: 'Cash Cobain' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/681be1a6c3b0474047fc722a_Influencers-v2.svg', alt: 'Influencers' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/6748060206a2a07bd3fc6b8f_WMG-Carousel-Imag.svg', alt: 'Warner Music Group' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/681be1a6e17bb658767ef610_eCommerce-v2.svg', alt: 'eCommerce' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/6644e2409796f8b88e5f0b2a_future.webp', alt: 'Future' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/680f985905abbee26488efb5_bulletpitch-Carousel-Imag.svg', alt: 'Bulletpitch' },
        { src: 'https://cdn.prod.website-files.com/61fc721130a4089acadae508/681be1a64209719b535d48f4_Entertainers-v2.svg', alt: 'Entertainers' }
    ];

    const SHOW_ADDITIONAL_SECTIONS = false;

    const renderAdditionalSections = () => {
        if (SHOW_ADDITIONAL_SECTIONS) {
            return (
                <>
                    <div className="section" style={{
                        ...sty.section,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <img src={TrustedBy} alt="Trusted By" style={sty.trustedBy} />
                    </div>

                    <div className="section" style={{
                        ...sty.section,
                        background: Colors.greyLighter,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <div className="sectionTitle" style={sty.sectionTitle}>
                            <h1 style={{
                                color: '#F7F7F2'
                            }}>BUILT FOR EVERY TYPE OF CREATOR, MARKETER, AND BUSINESS</h1>
                        </div>
                    </div>

                </>
            )
        }
        return null
    }
    return (
        <>
            <PageSymphony
                className="homepageComponent"
                style={styx(sty.homepageComponent, {
                    height: cssCalc(),
                    overflowY: 'scroll'
                })}
                isNoPadding
            >
                <Header />
                <div
                    className="homepageContent"
                    style={mStyle(sty, 'homepageContent')}
                >
                    <div
                        className="sectionTitle"
                        style={mStyle(sty, 'sectionTitle')}
                    >
                        <h1 style={{
                            color: '#F7F7F2'
                        }}>GROW ANYTHING</h1>
                        <h1
                            style={{
                                color: '#5EFEB1'
                            }}>ON AUTOPILOT</h1>

                    </div>
                    <p className="sectionSubtitle" style={mStyle(sty, 'sectionSubtitle')}>
                        Enter any link and run automated ads to grow. Save time, reach more people, and watch your business thrive.
                    </p>
                    <AdCreatorPage
                        className="adCreatorPageFromHomepage"
                        style={{
                            background: 'transparent'
                        }}
                        styleLayout={{
                            backgroundColor: 'transparent'
                        }}
                    />

                    <div className="poweredBySection" style={mStyle(sty, 'poweredBySection')}>
                        <p style={mStyle(sty, 'poweredByText')}>Our technology has powered campaigns for</p>
                        <div className="logoCarouselContainer" style={mStyle(sty, 'logoCarouselContainer')}>
                            <div className="logoCarouselTrack" style={mStyle(sty, 'logoCarouselTrack')}>
                                {carouselImages.map((image, index) => (
                                    <img
                                        key={makeKey('first', index)}
                                        className="logoCarouselImage1"
                                        style={mStyle(sty, 'carouselImage')}
                                        src={image.src}
                                        alt={image.alt}
                                        loading="lazy"
                                    />
                                ))}

                                {carouselImages.map((image, index) => (
                                    <img
                                        key={makeKey('second', index)}
                                        className="logoCarouselImage2"
                                        style={mStyle(sty, 'carouselImage')}
                                        src={image.src}
                                        alt={image.alt}
                                        loading="lazy"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* CSS for infinite scroll animation */}
                    <style>
                        {`
                            @keyframes scrollLeft {
                                0% {
                                    transform: translateX(0);
                                }
                                100% {
                                    transform: translateX(-50%);
                                }
                            }
                            
                            .logoCarouselTrack {
                                animation: scrollLeft 45s linear infinite;
                                will-change: transform;
                            }
                            
                            .logoCarouselTrack:hover {
                                animation-play-state: paused;
                            }
                            
                            .logoCarouselContainer {
                                mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
                                -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
                            }
                        `}
                    </style>
                </div>

                {renderAdditionalSections()}
            </PageSymphony>
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    homepageComponent: {
        background: Colors.greyHomepage,
    },
    homepageContent: {
        paddingTop: 180,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        width: '100%',
    },
    homepageContent_mobile: {
        paddingTop: 120,
    },
    sectionTitle: {
        fontSize: 72,
        textAlign: 'center',
        fontWeight: 800,
        lineHeight: 1,
        color: Colors.white
    },
    sectionTitle_mobile: {
        fontSize: 48,
    },
    trustedBy: {
        width: '100%',
        maxWidth: 800,
        margin: '0 auto'
    },
    poweredBySection: {
        marginTop: 60,
        marginBottom: 40,
    },
    poweredBySection_mobile: {
        marginTop: 30,
        marginBottom: 20,
    },
    poweredByText: {
        color: '#F7F7F2',
        textAlign: 'center',
        fontSize: 18,
        marginBottom: 48,
    },
    logoCarouselContainer: {
        overflow: 'hidden',
        width: '100%',
    },
    logoCarouselTrack: {
        display: 'flex',
        gap: 40,
        alignItems: 'center',
        height: '100%',
        whiteSpace: 'nowrap',
    },
    carouselImage: {
        height: 150,
        width: 'auto',
        maxWidth: 200,
        objectFit: 'contain',
        borderRadius: 12,
        transition: 'transform 0.3s ease, opacity 0.3s ease',
        flexShrink: 0,
    },
    sectionSubtitle: {
        color: '#F7F7F2',
        textAlign: 'center',
        maxWidth: 800,
        margin: '0 auto',
        fontSize: 18,
    },
    sectionSubtitle_mobile: {
        fontSize: 14,
    }
}

export default HomePage;